import { PlanningSprint } from '../services/strategicPlanningApi';

export const PLANNING_BACKLOG_ID = '__backlog__';

export type SprintTimeframe = 'past' | 'current' | 'future';

export function todayIsoDate(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function addDaysIso(isoDate: string, days: number): string {
  const date = new Date(`${isoDate}T12:00:00`);
  date.setDate(date.getDate() + days);
  return date.toISOString().slice(0, 10);
}

export function getSprintTimeframe(sprint: PlanningSprint, today = todayIsoDate()): SprintTimeframe {
  if (sprint.endDate < today) return 'past';
  if (sprint.startDate > today) return 'future';
  return 'current';
}

export function pickDefaultSprintId(sprints: PlanningSprint[], today = todayIsoDate()): string {
  const current = sprints.find((sprint) => getSprintTimeframe(sprint, today) === 'current');
  return current?.id ?? PLANNING_BACKLOG_ID;
}

const SPRINT_TIMEFRAME_ORDER: Record<SprintTimeframe, number> = {
  current: 0,
  future: 1,
  past: 2,
};

export function sortSprintsFromCurrentToLast(
  sprints: PlanningSprint[],
  today = todayIsoDate(),
): PlanningSprint[] {
  return [...sprints].sort((left, right) => {
    const leftFrame = getSprintTimeframe(left, today);
    const rightFrame = getSprintTimeframe(right, today);
    const frameDiff = SPRINT_TIMEFRAME_ORDER[leftFrame] - SPRINT_TIMEFRAME_ORDER[rightFrame];
    if (frameDiff !== 0) return frameDiff;

    const dateDiff = left.startDate.localeCompare(right.startDate);
    if (dateDiff !== 0) return dateDiff;

    return left.title.localeCompare(right.title);
  });
}
